import type { EmailStyle } from './generate';

export type PromptOptimizeContext = 'draft' | 'modify';

export interface OptimizePromptInput {
  prompt: string;
  context: PromptOptimizeContext;
  language?: string;
  style?: EmailStyle;
  scope?: 'whole' | 'element';
  scope_hint?: string;
}

export interface OptimizePromptResult {
  prompt: string;
}

export class OptimizePromptError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
    this.name = 'OptimizePromptError';
  }
}

export async function optimizePrompt(
  input: OptimizePromptInput,
  options?: { demo?: boolean },
): Promise<OptimizePromptResult> {
  const path = options?.demo ? '/api/prompt/optimize/demo' : '/api/prompt/optimize';
  const res = await fetch(path, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });

  if (!res.ok) {
    let msg = `Request failed (${res.status})`;
    try {
      const data = (await res.json()) as { error?: string; message?: string };
      msg = data.message || data.error || msg;
    } catch {
      /* ignore */
    }
    throw new OptimizePromptError(msg, res.status);
  }

  const data = (await res.json()) as { prompt?: string };
  if (!data.prompt || typeof data.prompt !== 'string') {
    throw new OptimizePromptError('Invalid response from server', 500);
  }
  return { prompt: data.prompt };
}
